<template>
  <span
    class="jade-badge"
    :class="computedClassName"
  >
    <span
      v-if="displayText"
      class="jade-badge__label-wrapper"
    >
      <JadeText
        variant="text-small"
        weight="semibold"
        color="current-color"
      >
        <slot />
      </JadeText>
    </span>
  </span>
</template>

<script>
import JadeText from '../JadeText/index.vue'

const VARIANT = {
  TEXT: 'text',
  DOT: 'dot'
}

export default {
  name: 'JadeBadge',

  components: {
    JadeText
  },

  props: {
    variant: {
      type: String,
      validation: voice => Object.values(VARIANT).includes(voice),
      default: VARIANT.TEXT
    },
    voice: {
      type: String,
      validation: voice =>
        ['info', 'negative', 'warning', 'positive', 'brand'].includes(voice),
      default: 'info'
    }
  },

  computed: {
    displayText () {
      return this.variant === VARIANT.TEXT && this.$slots.default
    },
    computedClassName () {
      return {
        [`is-${this.variant}`]: this.variant,
        [`is-voice-${this.voice}`]: this.voice
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/badge.css';
</style>
